<!-- @format -->

<template>
    <div id="app">
        <router-view v-if="isRouterAlive" />
    </div>
</template>
<script>
import { test, formal } from "@/config/index";

export default {
    name: "app",
    provide() {
        return {
            reload: this.reload,
        };
    },
    data() {
        return {
            form: {},
            isRouterAlive: true,
        };
    },
    mounted() {
        this._ajax.app = this;
    },
    methods: {
        reload() {
            this.isRouterAlive = false;
            this.$nextTick(() => {
                this.isRouterAlive = true;
            });
        },
    },
};
</script>
